import { render, staticRenderFns } from "./PaymentGiftCardForm.vue?vue&type=template&id=2b6bbe6c&scoped=true&"
import script from "./PaymentGiftCardForm.vue?vue&type=script&lang=js&"
export * from "./PaymentGiftCardForm.vue?vue&type=script&lang=js&"
import style0 from "./PaymentGiftCardForm.vue?vue&type=style&index=0&id=2b6bbe6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6bbe6c",
  null
  
)

export default component.exports